import React from 'react';
import { describe } from 'react-desc';
import SearchIcon from '@elliemae/ds-icons/Search';
import { DSIconColors } from '@elliemae/ds-icon';
import CloseXsmall from '@elliemae/ds-icons/CloseXsmall';
import { SearchBoxTextBox } from './styled.js';
import { SButton } from './SButton.js';
import { useSearch } from './useSearch.js';
import { searchBoxProps } from './props.js';
import { defaultProps } from './defaultProps.js';
import 'styled-components';
import '../TextBox/DSTextBox.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';
import '@elliemae/ds-system';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-utilities/utils';

/* eslint-disable complexity */

var DSSearchBox = function DSSearchBox(_ref) {
  var className = _ref.className,
      clearable = _ref.clearable,
      containerProps = _ref.containerProps,
      disableButton = _ref.disableButton,
      disabled = _ref.disabled,
      innerRef = _ref.innerRef,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onKeyUp = _ref.onKeyUp,
      onSearch = _ref.onSearch,
      placeholder = _ref.placeholder,
      property = _ref.property,
      readOnly = _ref.readOnly,
      searchOnEnter = _ref.searchOnEnter,
      onSearchButtonClick = _ref.onSearchButtonClick,
      showIcon = _ref.showIcon,
      style = _ref.style,
      value = _ref.value;

  var _useSearch = useSearch({
    onChange: onChange,
    onKeyUp: onKeyUp,
    onSearch: onSearch,
    onSearchButtonClick: onSearchButtonClick,
    property: property,
    searchOnEnter: searchOnEnter,
    value: value
  }),
      searchValue = _useSearch.searchValue,
      handleChange = _useSearch.handleChange,
      handleSearch = _useSearch.handleSearch,
      handleKeyUp = _useSearch.handleKeyUp,
      handleClear = _useSearch.handleClear;

  var shouldShowClearIcon = showIcon && clearable && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0;
  var shouldShowSearchIcon = !shouldShowClearIcon && showIcon;
  var shouldShowAnyIcon = shouldShowClearIcon || shouldShowSearchIcon;
  var PureSearchboxIcon = React.useMemo(function () {
    var Icon = /*#__PURE__*/React.createElement(SearchIcon, null);

    var handleOnClick = function handleOnClick() {
      return handleSearch(true);
    };

    if (!shouldShowAnyIcon) return null;

    if (shouldShowClearIcon) {
      Icon = /*#__PURE__*/React.createElement(CloseXsmall, {
        color: DSIconColors.PRIMARY
      });
      handleOnClick = handleClear;
    }

    return /*#__PURE__*/React.createElement(SButton, {
      disabled: disabled || disableButton,
      icon: Icon,
      onClick: handleOnClick
    });
  }, [shouldShowClearIcon, shouldShowSearchIcon, shouldShowAnyIcon, disabled, disableButton, handleSearch, handleClear]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 0
    }
  }, /*#__PURE__*/React.createElement(SearchBoxTextBox, {
    className: className,
    containerProps: containerProps,
    disabled: disabled,
    innerRef: innerRef,
    onChange: handleChange,
    onKeyUp: handleKeyUp,
    onBlur: onBlur,
    placeholder: placeholder,
    readOnly: readOnly,
    style: style,
    value: searchValue
  }), PureSearchboxIcon);
};

DSSearchBox.propTypes = searchBoxProps;
DSSearchBox.defaultProps = defaultProps;
var SearchBoxWithSchema = describe(DSSearchBox);
SearchBoxWithSchema.propTypes = searchBoxProps;

export default DSSearchBox;
export { SearchBoxWithSchema };
//# sourceMappingURL=DSSearchBox.js.map
